<i18n>
{
  "fr":{
    "Name": "Nom du programmeur"
  }
}
</i18n>

<template>
  <BaseSelect
    :label="$t('Name')"
    :options="formattedList"
    :validate="validate"
    empty
    @input="v=>$emit('input', v)" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    validate: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
      validator: value => ['DevOps', 'ConnectWise'].indexOf(value) !== -1,
    },
  },
  computed: {
    ...mapState('users', ['users']),
    ...mapState('members', ['members']),
    formattedList() {
      if (this.source === 'DevOps') {
        return this.users.map(user => ({
          label: user.user.displayName,
          value: user.id,
        }));
      }
      if (this.source === 'ConnectWise') {
        return this.members.map(member => ({
          label: `${member.firstName ? member.firstName : ''}, ${member.lastName ? member.lastName : ''}`,
          value: member.id,
        }));
      }
      return null;
    },
  },
  created() {
    this.$store.dispatch('users/getList');
  },
};
</script>
